import { useEffect, useState, useCallback } from "react";
import styled from "styled-components";
import Grid from "@mui/material/Grid";
import PastWinners from "../PastWinners";
import { useMyContext } from "@/app/utils/MyContext";
import { getInPageDisplayButtons } from "@/app/utils/request/requestList";
import { LANGTYPE_EN, useLanguage } from "@/app/utils/LanguageContext";
import _ from 'lodash';
import "@/app/style/raceSummary.scss";
import { defaultValue, getSearchParams, openTarget, redirectToLink, setRouting, adobeData, generateAdobeDataRaceNo, setRacesDetailLoading } from "@/app/utils/Common";
import { dateFormat, formattedDate, toDate } from "@/app/utils/DayJS";
import { text_size } from "@/app/utils/MixinSize";
import { MenuTab } from "@/app/utils/class/common/base";
import { menuTabSet } from "@/app/utils/constant/menuTabSet";
import FormGuidePDFViewer from "@/app/ui/PDFViewer/page";
import PhotosViewer from "@/app/ui/PhotosViewer/photosViewer";
import SinglePhotoWithZoom from "@/app/ui/PhotosViewer/singlePhotoWithZoom";
import Article from "@/app/ui/ArticleViewer/articleViewer"; 
import VideoGallery from "@/app/ui/Common/VideoGallery";
import { inPageDisplayButtonsTemplate, raceTemplate } from "@/app/utils/constant/template";
import { MenuTab as MenuTabClass } from "@/app/utils/class/common/base";
import { useLoading } from "@/app/utils/LoadingContext";

interface propType {
  setRacesDetailLoading: (loading: boolean) => void;
  isLoadingRacesDetail?: boolean;
  type: string;
  meetings: IMeeting[];
}

const Container = styled.div`
  border-radius: 0 0 4px 4px;
  background: white;
`;
const BottomContainer = styled('div')<{ $assetPrefix: string }>(({ $assetPrefix }) => `
  padding: 33px 15px 0 15px;
  background-image: url(${$assetPrefix}/text_bg.png);
  padding-bottom: 12px;
  border-radius: inherit; 
`);
const PresiteContainer = styled('div')<{ $assetPrefix: string }>(({ $assetPrefix }) => `
  background-image: url(${$assetPrefix}/text_bg.png);
  padding: 12px;
  border-radius: inherit;
`);
const TopContainer = styled('div')<{ $assetPrefix: string }>(({ $assetPrefix }) => `
    padding: 17px;
    display: flex;
    padding: 12px 12px;
    display: flex;
    height: 162px;
    width: 100%;
    position: relative;
    background-image: url(${$assetPrefix}/raceCardBanner.svg);
    background-size: cover;
    height: 162px;
`);
const BaseInfoLeft = styled.div`
  width: 340px;
  max-width: 50%;
`;

const BaseInfoRight = styled.div`
  flex: 1;
  justify-content: center;
  align-items: center;
  display: flex;
  min-width: 30%;
  max-width: 30%;
`;
const BaseInfoWrapper = styled.div`
  div:nth-of-type(1) {
    margin: 0;
  }
`;
const BaseInfoItem = styled.div`
  margin-top: 6px;
  display: flex;
  span {
    text-align: left;
    width: 74px;
    @media only screen and (min-width: 1680px) {
      width: 86px;
    }
    ${text_size(13)}
    font-weight: 300;
    line-height: 17.71px;
    color: rgba(18, 44, 104, 1);
  }
  p {
    margin-left: 32px;
    ${text_size(13)}
    font-weight: 500;
    line-height: 17.71px;
    text-align: left;
    color: black;
  }
`;
const AnalysisWrapper = styled.div`
  min-height: 134px;
`;
const AnalysisTitle = styled.div`
  display: flex;
  align-items: center;
  height: 36px;
  padding: 8px 12px;
  width: 100%;
  background: #6176A0;
  p {
    ${text_size(13)}
    font-weight: 500;
    line-height: 16px;
    color: white;
  }
`;

const AnalysisMenuInPage = styled.div`
  height: 724px;
  background: #C1CBE1;
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  padding: 12px;
`;

const AnalysisItemWrapper = styled.div`
  padding-right: 2px;
  overflow-y:auto;
  overflow-x:hidden;
  height: 700px;

  &::-webkit-scrollbar-thumb {
    background-color: #e3e3e3;
    -webkit-border-radius: 4px;
  }
  &::-webkit-scrollbar-thumb:hover {
    background-color: #e3e3e3;
    -webkit-border-radius: 4px;
  }
  &::-webkit-scrollbar {
    width: 6px;
    height: 6px;
  }
  &::-webkit-scrollbar-track-piece {
    -webkit-border-radius: 0;
  }
  &::-webkit-scrollbar-thumb:active{
    background-color:#cccccc;
    -webkit-border-radius:4px;
  } 
`;
const AnalysisItem = styled.div`
  margin-bottom: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 48px;
  width: 160px;
  padding: 10px;
  background: white;
  box-shadow: 0px 4px 4px 0px rgba(48, 48, 48, 0.05);
  text-align: center;
  border-radius: 4px;
  p {
    ${text_size(13)}
    font-weight: 500;
    text-align: center;
    color: rgba(18, 44, 104, 1);
    line-height: 20px;
    max-height: 40px;
    overflow: hidden;
  }
`;
const AnalysisContent = styled.div`
  margin-left: 6px;
  background: white;
  border-radius: 4px;
  width: calc(100% - 172px);
  height: 700px;
  position: relative;
  overflow: hidden;
`;

const RowSplitLine = styled.div` 
  margin-bottom: 16px;
  height: 1px;
  width: 100%;
  background: rgba(180, 180, 180, 1);
`;
const BottomContent = styled.div`
  position: relative;
  width: 100%;
  max-width: 893px;
  overflow: auto;
  text-align: left;
  ${text_size(13)}
`;
const MobileContainer = styled.div`
  padding: 12px;
  border-radius: 0 0 4px 4px;
  background: white;
`;
const MobileTopItem = styled.div`
  display: flex;
  align-items: center;
  p {
    ${text_size(13)}
    font-weight: 300;
    line-height: 17.71px;
    min-width: 72px;
    color: rgba(18, 44, 104, 1);
  }
  span {
    flex: 1;
    ${text_size(13)}
    font-weight: 500;
    line-height: 17.71px;
    text-align: left;
    margin-left: 32.35px;
  }
`;
const MobileTAnalysisMenu = styled.div`
  background: #C1CBE1;
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  padding: 12px 0 0 12px;
  border-radius: 0 0 4px 4px;

  .item_padding
  {
    padding-right: 12px;
    padding-bottom: 12px;
  }
`;
const SpaceBlock6 = styled.div`
  margin: 3px 0;
`;
const RaceImgWrapper = styled.div`
  width: 100%;
  text-align: center;
  img {
    object-fit: cover;
    width: 207.49px;
  }
`;
const MobileAnalysisWrapper = styled.div`
  border-radius: 4px;
`;
const MAnalysis = styled.div`
  display: flex;
  align-items: center;
  height: 36px;
  padding: 8px 12px;
  width: 100%;
  background: #6176A0;
  border-radius: 4px 4px 0px 0px;
  p {
    ${text_size(13)}
    font-weight: 500;
    line-height: 16px;
    color: white;
  }
`;
const MAnalysisItem = styled.div`
  display: flex;
  padding: 0 10px;
  justify-content: center;
  align-items: center;
  text-align: center;
  height: 48px;
  border-radius: 4px;
  box-shadow: 0px 4px 4px 0px rgba(48, 48, 48, 0.05);
  background: rgba(255, 255, 255, 1);
  p {
    ${text_size(13)}
    color: rgba(18, 44, 104, 1);
    line-height: 20px;
    max-height: 40px;
    overflow: hidden;
  }
`;
const SplitDiv = styled.div`
  width: 100%;
  height: 1px;
  background-color: rgba(180, 180, 180, 1);
  margin: 21px 0 11px;
`;
const BottomContentM = styled.div`
  max-width: 858px;
  width: 100%;
  overflow: auto;
  text-align: left;
  ${text_size(13)}
`;

interface ButtonType {
  inStandardButton: boolean;
  templateName: string;  //Standard Button use redirectionLink.toLowerCase() match menuTabSet, except Speed Map
  name: string;
  displayName: string;
  Url?: string;
  openTarget?: string;
  data?: any;
}

const RaceSummary: React.FC<propType> = (props) => {
  const { triggerLoading, completeLoading } = useLoading();
  const {state:lang} = useLanguage();
  const {t} = lang;
  const {state: myContextState, dispatch: myContextDispatch } = useMyContext();
  const [inPageDisplay, setInPageDisplay] = useState<any>(null);
  const [inPageBtnIndex, setInPageBtnIndex] = useState(0);
  const [isShowhighlight, setIsShowhighlight] = useState<boolean>(false);
  const { b_cid } = getSearchParams(new URLSearchParams(window.location.search));

  const [inPageDisplayBtns,setInPageDisplayBtns]=useState<any>(null);

  const GetSpeedMapBtn=(speedMapItem:any, defaultSetLabel:string):ButtonType=>{
    if(speedMapItem?.url && defaultSetLabel!=''){
      return {
        inStandardButton: true,
        templateName: 'SpeedMap',
        name: '',
        Url: speedMapItem?.url,
        displayName: defaultSetLabel,
        data: speedMapItem
      };
    }else{
      return {
        inStandardButton: true,
        templateName: '',
        name: '',
        displayName: ''};   
    }    
  }


  const GetStandardBtnsBySearchResult=(buttons:any,displayName:string, redirectionLink:string):ButtonType=>{

    if(!buttons || displayName=='' || redirectionLink =='')
     return {
      inStandardButton: true,
      templateName: '',
      name: '',
      displayName: ''};

    const sRaceNo = myContextState.selectedRaceNo;
    const pageName = redirectionLink.toLowerCase();
    const templateName = GetTemplateNameByPageName(pageName);

    if(templateName =='ExpertColumn' || templateName =='FormComments') //Meeting/Races/Race2/ExpertColumn|FormComments
    {
      const races = buttons?.filter((x:any)=> x.template.name=="Races")[0]?.children;
      if(races!=null){
        let hasRace = false;
        _.forEach(races, function(raceItem) {
          if(sRaceNo.isEqual(raceItem.name))
          {
            const childrenItem = raceItem?.children?.filter((y:any)=> y.template.name==templateName);
            if(childrenItem!=null && childrenItem.length>0 && GetStandardBtnsVersion(childrenItem[0].versions))
            {
              hasRace = true;
            } 
          }
        });
        if(hasRace) 
        return {
          inStandardButton: true,
          templateName: pageName,
          name: '',
          displayName: displayName};
      }
    }
    else if(templateName =='TrackAnalysis' || templateName =='RacingStatistics' ) //Meeting/TrackAnalysis|RacingStatistics
    {
      const hasNode = buttons?.filter((x:any)=> x.template.name==templateName);
      if(hasNode.length>0 && GetStandardBtnsVersion(hasNode[0].versions)){
        return {
          inStandardButton: true,
          templateName: pageName,
          name: '',
          displayName: displayName};
      }
    }
    else if(templateName =='JockeysTrainersRankings')//Meeting/JockeysTrainersRankings/{children}
    {
      const hasNode = buttons?.filter((x:any)=> x.template.name==templateName);
      if(hasNode?.[0]?.children?.[0] !=null && GetStandardBtnsVersion(hasNode?.[0].versions)){
        return {
          inStandardButton: true,
          templateName: pageName,
          name: '',
          displayName: displayName};
      }
    }
    else if(templateName =='TipstersSelections' )//Meeting/TipstersSelections/TipstersSelectionTable(Race)
    {
      const hasNode = buttons?.filter((x:any)=> x.template.name==templateName);
      if (hasNode?.length && GetStandardBtnsVersion(hasNode?.[0]?.versions)) {
        let tempObj = {} as ButtonType;
        for (let i = 0; i<hasNode?.[0]?.children?.length; i++){
          const targetItem = hasNode?.[0]?.children?.[i]?.selectedRaceTipstersSelections?.targetItem;
          const matchRace = myContextState.selectedMeeting?.isValidTemplateItem([raceTemplate.ID], targetItem, true) && sRaceNo.isEqual(targetItem?.name);
          if(matchRace)
            {
              tempObj = {
                inStandardButton: true,
                templateName: pageName,
                name: '',
                displayName: displayName};
                break; 
            }
        }

        if (Object.keys(tempObj).length) return tempObj  
      }
    }else{
      return {
        inStandardButton: true,
        templateName: templateName,
        name: '',
        displayName: displayName
      }; 
    }
    return {
      inStandardButton: true,
      templateName: '',
      name: '',
      displayName: ''
    }; 
  }

  const GetTemplateNameByPageName=(pageName:string): string=>{
    let templateName = pageName;
    //const StandardButtons =['TipstersSelections','ExpertColumn','RacingStatistics','TrackAnalysis','FormComments','JockeysTrainersRankings'];
    switch (pageName) {
      case menuTabSet.JOCKEY_TRAINER_RANKING:
        templateName = 'JockeysTrainersRankings';
        break;
      case menuTabSet.TRACK_ANALYSIS:
        templateName = 'TrackAnalysis';
        break;
      case menuTabSet.FORM_COMMENT:
        templateName = 'FormComments';
        break;
      case menuTabSet.EXPERT_COLUMN:
        templateName = 'ExpertColumn';
        break;
      case menuTabSet.TIPSTERS_SELECTION:
        templateName = 'TipstersSelections';
        break;
      case menuTabSet.RACING_STATISTICS:
        templateName = 'RacingStatistics';
        break;
    }
    return templateName;
  }

  const GetStandardBtnsVersion=(versions:any): boolean=>{
    return versions?.[0]?.version >0 
  }


  const GetDynamicButton=(button:any):ButtonType=>{
    let hasRace = false;
    let btnInfo: ButtonType = {
      inStandardButton: false,
      templateName: '',
      name: '',
      displayName: ''};

    if(!button) return btnInfo;

    const tempName = button.template?.name;
    const btnLabel = button.displayName?.value || '';
    const sRaceNo = myContextState.selectedRaceNo;
    const buttonName = button.name;

    const specialHandlingTemplate = [
      inPageDisplayButtonsTemplate.VIDEO_BUTTON.NAME,
      inPageDisplayButtonsTemplate.MULTIPLE_PHOTO_BUTTON.NAME,
    ]
    const matchRaceInChildTemplate = [
      inPageDisplayButtonsTemplate.ARTICLE_BUTTON.NAME,
    ]
    const matchRaceInRootTemplate = [
      inPageDisplayButtonsTemplate.PDF_BUTTON.NAME,
      inPageDisplayButtonsTemplate.URL_BUTTON.NAME,
      inPageDisplayButtonsTemplate.SINGLE_PHOTO_BUTTON.NAME,
    ]

    console.log("getInPageDisplayButtons99.86",buttonName,tempName, button);

    if (matchRaceInChildTemplate.includes(tempName)){
      console.log('matchRaceInChildTemplate', button)
      if(btnLabel=='' || button.children?.length === 0) return btnInfo;

      const validItem = (tempName: string, item: any) => {
        switch (tempName) {
          case inPageDisplayButtonsTemplate.ARTICLE_BUTTON.NAME:
            return item.selectedRace?.targetItems?.length>0
        }
        return false
      }

      const matchedData = button.children.filter((item:any) => {
        const hasValue = validItem(tempName, item)
        const matchRace = item.selectedRace?.targetItems?.some((r: any) => 
          myContextState.selectedMeeting?.isValidTemplateItem([raceTemplate.ID], r) &&
          sRaceNo.isEqual(r.name)
        )
        return hasValue && matchRace
      })

      hasRace = matchedData.length
      console.log("getInPageDisplayButtons99.87",tempName, button,hasRace);
      if (hasRace) {        
        btnInfo = {
          inStandardButton: false,
          templateName: tempName,
          name: buttonName,
          displayName: btnLabel,
          data: matchedData
        }
      }
    } else if (matchRaceInRootTemplate.includes(tempName)){
      console.log('matchRaceInRootTemplate', button)
      const invalidButton = (tempName: string, item: any) => {
        switch (tempName) {
          case inPageDisplayButtonsTemplate.URL_BUTTON.NAME:
            return btnLabel=='' || (button.URLLink?.value || '') === '' || button.selectedRaceInRoot?.targetItems?.length === 0
          case inPageDisplayButtonsTemplate.PDF_BUTTON.NAME:
            return btnLabel=='' || (button.PDFLink?.url || '') === '' || button.selectedRaceInRoot?.targetItems?.length === 0
          case inPageDisplayButtonsTemplate.SINGLE_PHOTO_BUTTON.NAME:
              return btnLabel=='' || (button.singlePhoto?.src || '') === '' || button.selectedRaceInRoot?.targetItems?.length === 0
        }
        return
      }
      const getDataByTemplate = (tempName: string, item: any) => {
        switch (tempName) {
          case inPageDisplayButtonsTemplate.URL_BUTTON.NAME:
            return item.URLLink?.value
          case inPageDisplayButtonsTemplate.PDF_BUTTON.NAME:
            return item.PDFLink?.url
        }
        return
      }
      const matchRace = button.selectedRaceInRoot?.targetItems?.some((r: any) => 
        myContextState.selectedMeeting?.isValidTemplateItem([raceTemplate.ID], r) &&
        sRaceNo.isEqual(r.name)
      )
      console.log("getInPageDisplayButtons99.88",tempName, button, matchRace, !invalidButton(tempName, button));
      if (matchRace && !invalidButton(tempName, button)) {
        btnInfo = {
          inStandardButton: false,
          templateName: tempName,
          name: buttonName,
          displayName: btnLabel,
          Url: getDataByTemplate(tempName, button),
          openTarget: button.target?.value,
          data: tempName == inPageDisplayButtonsTemplate.SINGLE_PHOTO_BUTTON.NAME ? button : null
        }
        console.log("getInPageDisplayButtons99.88",tempName, button,btnInfo);
      }      
    } else if (specialHandlingTemplate.includes(tempName)){
      console.log('specialHandlingTemplate', button)
      if(btnLabel=='' || button.children?.length === 0) return btnInfo;

      const validItem = (tempName: string, item: any) => {
        switch (tempName) {
          case inPageDisplayButtonsTemplate.VIDEO_BUTTON.NAME:
            return (item.videoTitle?.value||"")!="" && (item.videoThumbnail?.src||"")!="" && (item.videoURL?.value||"")!=""
          case inPageDisplayButtonsTemplate.MULTIPLE_PHOTO_BUTTON.NAME:
            return (item.photo?.src||"")!=""
        }
        return false
      }

      const matchedData = button.children.filter((item:any) => {
        const hasValue = validItem(tempName, item)
        return hasValue
      })

      hasRace = matchedData.length
      console.log("getInPageDisplayButtons99.89",tempName, button,hasRace);
      if (hasRace) {        
        btnInfo = {
          inStandardButton: false,
          templateName: tempName,
          name: buttonName,
          displayName: btnLabel,
          data: matchedData
        }
      }
    }

    return btnInfo
  }

  const SetSelectedButtonClass=(name: string):boolean=>{
    console.log("SetSelectedButtonClass", name, inPageDisplay);
    if(inPageDisplay?.inStandardButton && inPageDisplay?.templateName ==name)
    {
      if(inPageDisplay?.templateName=='SpeedMap')
      {
        return true;
      }
    }
    else if(!inPageDisplay?.inStandardButton && inPageDisplay?.name ==name){
      if(inPageDisplay?.templateName!='URLButton')
      {
        return true;
      }
    }

    return false;
  }

  useEffect(()=>{
    if (myContextState.isChangingMeeting) return
    //20240224/20240224_S1_R1_EN
    const meetingtDate = formattedDate(myContextState.selectedMeetingDate, "YYYYMMDD");
    const venueCode = myContextState.selectedMeetingVenueCode;
    const langCode = lang.langType === LANGTYPE_EN ? "EN" : "CH";
    const speedMapImagePath = `${meetingtDate}/${meetingtDate}_${venueCode}_R${myContextState.selectedRaceNo.valueOf()}_${langCode}`;
        
    getInPageDisplayButtons(lang.langCode, myContextState.season, myContextState.selectedMeeting?.displayName, speedMapImagePath).then((res)=>{
      const highlightBtnArr : ButtonType[] = []
      console.log("getInPageDisplayButtons",res?.item, res?.defaultButtons);
      if(res?.defaultButtons?.buttons?.length)
      {
        for(const nameIndex in res?.defaultButtons?.buttons){
          const button = res?.defaultButtons?.buttons[nameIndex];
          if(button?.template?.name=='SpeedmapButton')//Speed Map
          {
            const speedMapBtn:ButtonType=GetSpeedMapBtn(res?.speedMapItem, button?.displayName?.value||'');
            if(speedMapBtn.displayName!=''){
              highlightBtnArr.push(speedMapBtn)
            }
          }
          else if(res?.defaultButtons?.buttons[nameIndex]?.template?.name=='URLButton')
          {
            const btn:ButtonType=GetStandardBtnsBySearchResult(res?.item?.buttons, button?.displayName?.value||'', button?.redirectionLink?.value||'')
            if(btn.displayName!=''){
              highlightBtnArr.push(btn)
            }
          }
        }
      }

      //get InPageDisplayButtons dynamic buttons
      const dynamicButtonsData = res?.item?.buttons?.filter((x:any)=> x.template.name=="InPageDisplayButtons")[0]?.children;
      //setDynamicButtonsData(dynamicButtonsData);

      console.log("getInPageDisplayButtons99.2",dynamicButtonsData);
      if(dynamicButtonsData?.length>0){
        dynamicButtonsData.map((button:any) => {
          const btn:ButtonType=GetDynamicButton(button)
          if(btn.displayName!=''){
            highlightBtnArr.push(btn)
          } 
        })
      } 

      //Default when arriving simulcast web
      let isHighlightShow = false;
      for(const highlightItem of highlightBtnArr){

        if(highlightItem?.inStandardButton)
        {
          if(highlightItem?.templateName =='SpeedMap')
          {
            isHighlightShow = true;
            props?.type == "pc" && setInPageDisplay(highlightItem);
            break;
          }
        }
        else{
          if(highlightItem?.templateName!='URLButton'){
            isHighlightShow = true;
            props?.type == "pc" && setInPageDisplay(highlightItem);
            break;
          }
        }
      }
      console.log("getInPageDisplayButtons99",isHighlightShow, highlightBtnArr);
      setIsShowhighlight(isHighlightShow);
      if(isHighlightShow)
      {
        setInPageDisplayBtns(highlightBtnArr);
      }
    }).finally(() => {
      setRacesDetailLoading(props.setRacesDetailLoading)
      completeLoading('page');
    })
  }, [myContextState.selectedRace, myContextState.isChangingMeeting])


  const handleTrackmapClick = () => {
    const trackAnalysisMenuTab = new MenuTab(menuTabSet.TRACK_ANALYSIS)
    setRacesDetailLoading(props.setRacesDetailLoading, menuTabSet.TRACK_ANALYSIS, true)
    triggerLoading('page', menuTabSet.TRACK_ANALYSIS);
    setRouting(`/${encodeURIComponent(trackAnalysisMenuTab.valueOf())}`, {b_cid: ''}, myContextState);
    myContextDispatch({type: 'update', value:{menuTab: trackAnalysisMenuTab}})
  }

  const renderPresiteInfo = () => {
    return props?.type === "pc" ?  (
      <Container>
        <PresiteContainer $assetPrefix={myContextState.assetPrefix}>
          <BottomContent>
            <div dangerouslySetInnerHTML={{__html: defaultValue(myContextState.selectedMeeting?.meetingDescription, '')}} />
          </BottomContent>
        </PresiteContainer>
      </Container>
    ) : (
      <MobileContainer>
        <BottomContentM>
          <div dangerouslySetInnerHTML={{__html: defaultValue(myContextState.selectedMeeting?.meetingDescription, '')}} />
        </BottomContentM>
      </MobileContainer>
    )
  }

    
  function sleep(ms:any) {
    return new Promise(resolve => setTimeout(resolve, ms));
  }
//__RenderTabPanel
const scollToTop= (counter:number)=>{
  window.RaceSummaryScoll=(counter:number)=>{
    (async (counter)=>{   
      // console.log(counter)
      if(counter>=100) return    
      const tarDomID = props?.type === 'pc' ? 'meetingRacingInfo' : 'race_detail_name';
      const clientView=document.getElementById(tarDomID)?.getBoundingClientRect()
      if(clientView){   
          const top=clientView.top
          document.body.scrollTop=document.body.scrollTop+top       
          await sleep(300)
          const clientView2=document.getElementById(tarDomID)?.getBoundingClientRect()
          if(clientView2){
            if(clientView2.top>1){                  
              scollToTop(counter+1)
            }
          }
          
      }
    })(counter)
  } 
  window.RaceSummaryScoll(counter) 
}

  const handleInPageDisplay=async (btnItem:any, index:number)=>{
     
    // adobeAnalysis // 1. PRJ2555-1429 Click on dynmaic items
    adobeData(lang.langType === LANGTYPE_EN ? "en" : "zh-hk", "interaction", {
      pageId: "racing/simulcast",
      eventId: "racing/simulcast_Click_RaceSummary_HighlightComponent", 
      buttonName: "racing/simulcast_Click_"+ btnItem.templateName,
      raceNo: generateAdobeDataRaceNo(myContextState.selectedMeetingDate, myContextState.selectedMeetingVenueCode, myContextState.selectedRaceNo.valueOf())
    });
    
    setInPageBtnIndex(index);
    if(btnItem.templateName=="URLButton")
    {
      redirectToLink(btnItem.Url, openTarget(btnItem.openTarget));
      scollToTop(1)
    }else if(btnItem?.inStandardButton && btnItem?.templateName!='SpeedMap')
    {
      setTimeout(() => {
        standardButtonLinkto(btnItem?.templateName); 
      }, 100);
      
      scollToTop(1)
    }
    else
    {
      setInPageDisplay(btnItem)
    }
  }

  const standardButtonLinkto = (tab: any) => {   
    const newTab = new MenuTabClass(tab)
    setRacesDetailLoading(props.setRacesDetailLoading, tab, true)
    triggerLoading('page', newTab.toString());
    setRouting(`/${encodeURIComponent(newTab.valueOf())}`, {b_cid: ''}, myContextState);
    myContextDispatch({type: "update", value: {menuTab: newTab}});
  };

  const handleInPageDisplayClose=useCallback(()=>{
    setInPageDisplay({
      inStandardButton: false,
      templateName: '',
      name: '',
      displayName: ''})
  },[])

  const renderInPageDisplay=()=>{
      let render=null

      const displayName = inPageDisplay?.displayName || '';

      if(displayName=='')
        return null;
      
      const templateName = inPageDisplay?.templateName;
      if(inPageDisplay?.inStandardButton)
      { 
        if(templateName=='SpeedMap') {
          render=<SinglePhotoWithZoom isSpeedMap={true} key={templateName+inPageBtnIndex} data={inPageDisplay?.data} type={props?.type} isOpen={true} onRequestClose={handleInPageDisplayClose} />
        }
      }else{
        const name = inPageDisplay?.name;
        switch (templateName) {
          case inPageDisplayButtonsTemplate.PDF_BUTTON.NAME: 
            render=<FormGuidePDFViewer url={inPageDisplay?.Url} key={templateName+inPageBtnIndex} type={props?.type} onClose={handleInPageDisplayClose}></FormGuidePDFViewer>
            break;
          case inPageDisplayButtonsTemplate.MULTIPLE_PHOTO_BUTTON.NAME: 
            render=<PhotosViewer data={inPageDisplay?.data} key={templateName+inPageBtnIndex} type={props?.type} isOpen={true} onRequestClose={handleInPageDisplayClose} />
            break;
          case inPageDisplayButtonsTemplate.SINGLE_PHOTO_BUTTON.NAME: 
            render=<SinglePhotoWithZoom isSpeedMap={false} key={templateName+inPageBtnIndex} type={props?.type} data={inPageDisplay?.data} isOpen={true} onRequestClose={handleInPageDisplayClose} />
            break;
          case inPageDisplayButtonsTemplate.ARTICLE_BUTTON.NAME: 
            render=<Article type={props?.type} isOpen={true} key={templateName+inPageBtnIndex} name={name} onRequestClose={handleInPageDisplayClose} />
            break;
          case inPageDisplayButtonsTemplate.VIDEO_BUTTON.NAME:
            render=<VideoGallery isMobile={props?.type !== "pc"} key={templateName+inPageBtnIndex} data={inPageDisplay?.data} title={displayName} onClose={handleInPageDisplayClose} />
            break;
          default:
            break;
        }
      }
      return render;
  }

  return (
    <>
      {
        myContextState.selectedMeeting?.isPresite() ? renderPresiteInfo() : 
        (props?.type === "pc" ? (
        <Container>
          {/* <TopContainer $assetPrefix={myContextState.assetPrefix}>
            <BaseInfoLeft>
              <BaseInfoWrapper>
                <BaseInfoItem id="race_summary_pc_datetime">
                  <span>{t("race_summary_datetime")}</span>
                  <p>{defaultValue(formattedDate(toDate(myContextState.selectedRace?.raceDatetime?.value, dateFormat.cms.datetime), dateFormat.display.fulldatetime), '-')}</p>
                </BaseInfoItem>
                <BaseInfoItem id="race_summary_pc_dist">
                  <span>{t("race_summary_dist")}</span>
                  <p>{defaultValue(myContextState.selectedRace?.raceDistance, '-')}</p>
                </BaseInfoItem>
                <BaseInfoItem id="race_summary_pc_group">
                  <span>{t("race_summary_group")}</span>
                  <p>{defaultValue(myContextState.selectedRace?.group, '-')}</p>
                </BaseInfoItem>
              </BaseInfoWrapper>
            </BaseInfoLeft>
            <BaseInfoRight>
              <img className={`trackMapImg${myContextState.selectedRace?.trackMap?.src ? ' clickable' : ''}${myContextState.selectedRace?.trackMap ? '' : ' hidden'}`} alt={defaultValue(myContextState.selectedRace?.trackMap?.alt, '')} src={defaultValue(myContextState.selectedRace?.trackMap?.src, '')} onClick={() => handleTrackmapClick()}/>
            </BaseInfoRight>
          </TopContainer> */}
          { isShowhighlight && inPageDisplayBtns?.length > 0 &&
                (
                  <AnalysisWrapper>
                    <AnalysisTitle id="race_summary_inPageDisplayBtn_title_pc">
                      <p>{t("race_summary_highlight")}</p>
                    </AnalysisTitle>
                    <AnalysisMenuInPage>
                    <AnalysisItemWrapper  id="race_summary_inPageDisplayBtn_menu_pc">
                        {
                          inPageDisplayBtns.map((btn:any, index:number)=>(
                            <Grid item key={index}>
                              <AnalysisItem className={`clickable ${SetSelectedButtonClass(btn.inStandardButton? btn.templateName :btn.name) ? 'highlight_active' : '' }`} onClick={()=>{handleInPageDisplay(btn, index)}}>
                                <p>{defaultValue(btn.displayName, '')}</p>
                              </AnalysisItem>
                            </Grid>
                          ))
                        }
                    </AnalysisItemWrapper>
                    <AnalysisContent>
                    {renderInPageDisplay()}
                    </AnalysisContent>
                    </AnalysisMenuInPage>
                  </AnalysisWrapper>
                )
          }
          <PastWinners type="pc" meetings={props.meetings}></PastWinners>
          <BottomContainer $assetPrefix={myContextState.assetPrefix}>
            <RowSplitLine />
            <BottomContent>
              <div id="past_winners_raceDescription_pc" dangerouslySetInnerHTML={{__html: defaultValue(myContextState.selectedRace?.raceDescription, '')}} />
            </BottomContent>
          </BottomContainer>
        </Container>
      ) : (
        <MobileContainer>
          {/* <MobileTopItem  id="race_summary_mobile_datetime">
            <p>{t("race_summary_datetime")}</p>
            <span>{defaultValue(formattedDate(toDate(myContextState.selectedRace?.raceDatetime?.value, dateFormat.cms.datetime), dateFormat.display.fulldatetime), '-')}</span>
          </MobileTopItem>
          <SpaceBlock6 />
          <MobileTopItem id="race_summary_mobile_dist">
            <p>{t("race_summary_dist")}</p>
            <span>{defaultValue(myContextState.selectedRace?.raceDistance, '-')}</span>
          </MobileTopItem>
          <SpaceBlock6 />
          <MobileTopItem id="race_summary_mobile_group">
            <p>{t("race_summary_group")}</p>
            <span>{defaultValue(myContextState.selectedRace?.group, '-')}</span>
          </MobileTopItem>
          <RaceImgWrapper>
            <img className={`trackMapImg${myContextState.selectedRace?.trackMap?.src ? ' clickable' : ''}${myContextState.selectedRace?.trackMap ? '' : ' hidden'}`} alt={defaultValue(myContextState.selectedRace?.trackMap?.alt, '')} src={defaultValue(myContextState.selectedRace?.trackMap?.src, '')} onClick={() => handleTrackmapClick()}  />
          </RaceImgWrapper> */}
          {isShowhighlight && inPageDisplayBtns?.length > 0 && (
              <MobileAnalysisWrapper id="race_summary_inPageDisplayBtn_Mobile">
                <MAnalysis id="race_summary_inPageDisplayBtn_title_Mobile">
                  <p>{t("race_summary_highlight")}</p>
                </MAnalysis>
                <MobileTAnalysisMenu id="race_summary_inPageDisplayBtn_menu_Mobile">
                  <Grid container>
                  {
                    inPageDisplayBtns.map((btn:any, index:number)=>(
                      <Grid item xs={6} key={index} className="item_padding">
                        <MAnalysisItem className="clickable" onClick={()=>{handleInPageDisplay(btn, index)}}>
                          <p>{defaultValue(btn.displayName, '')}</p>
                        </MAnalysisItem>
                      </Grid>
                    ))
                  }
                  </Grid>
                </MobileTAnalysisMenu>
              </MobileAnalysisWrapper>
            )
          }
          <div style={{display:"inline",height:"0px"}}>
            {renderInPageDisplay()}
          </div>
          <PastWinners meetings={props.meetings} type={'mobile'}></PastWinners>
          <SplitDiv />
          <BottomContentM>
            <div id="past_winners_raceDescription_mobile" dangerouslySetInnerHTML={{__html:defaultValue(myContextState.selectedRace?.raceDescription, '')}} />
          </BottomContentM>     
        </MobileContainer>
      ))}
    </>
  );
};
export default RaceSummary;
